module.exports = __webpack_public_path__ + "static/img/English.6f382b2.png";